import { StepHead } from "../StepHead";
import { WizardLayout } from "../WizardLayout";
import { BudgetPicker } from "../BudgetPicker";

/**
 * The dedicated /campaign/new/budget step. No longer in WIZARD_STEPS — the
 * route stays so the page is reachable by direct URL (or for re-enabling
 * the step later). All UI lives in <BudgetPicker> which is also used by the
 * "Как определить бюджет?" popover on the Bloggers step.
 */
export function BudgetStep() {
  return (
    <WizardLayout>
      <StepHead step="02" title="Бюджет и прогноз" sub="Выберите готовую сумму или двигайте ползунок — медиаплан пересчитывается в реальном времени." />
      <BudgetPicker />
    </WizardLayout>
  );
}
